import {createFileRoute} from '@tanstack/react-router'
import {CyclesPage} from '@/features/cycles/CyclesPage'

// Ungated: the cycle list is a read surface for everyone; management actions
// inside it render only for cycles:manage holders (see CyclesPage).
export const Route = createFileRoute('/sprints/cycles')({
	component: CyclesPage,
})
